import React from 'react';
import styled from 'styled-components/macro';
import { Flex } from 'components/ui';
import { Chord } from 'utils/EulerBeatsWrapper';

const Content = styled<any>(Flex)`
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: ${props => props.lastChordProgress}%;
    background-color: white;
    transition: all 0.1s;
  }
`;

const Chords = (props: {
  lastChordIndex?: number;
  lastChordIsPlaying: boolean;
  lastChordProgress?: number;
  chords?: Chord[];
}) => {
  if (!props.chords) {
    return null;
  }
  let chordCurrent: Chord | null = null;
  let chordPrev: Chord | null = null;
  let chordNext: Chord | null = null;
  if (props.lastChordIndex == null) {
    chordNext = props.chords[0];
  } else {
    if (props.lastChordIsPlaying) {
      chordCurrent = props.chords[props.lastChordIndex];
      chordPrev = props.chords[props.lastChordIndex - 1];
    } else {
      chordPrev = props.chords[props.lastChordIndex];
    }
    chordNext = props.chords[props.lastChordIndex + 1];
  }
  const formatChord = (chord: Chord | null) =>
    chord && (
      <>
        <span>{chord.nameBase}</span>
        <span style={{opacity: 0.5}}>{chord.nameModifier}</span>
      </>
    );
  return (
    <>
      <Content
        position="absolute"
        left="50%"
        bottom="100px"
        width="280px"
        marginLeft="-140px"
        py={2}
        px={1}
        borderRadius="3px"
        backgroundColor="rgba(0, 0, 0, 0.75)"
        color="white"
        textAlign="center"
        lastChordProgress={props.lastChordProgress}
      >
        <span style={{ width: '100%' }}>{formatChord(chordPrev)}</span>
        <span style={{ width: '100%' }}>
          <b>{formatChord(chordCurrent)} </b>
        </span>
        <span style={{ width: '100%' }}>{formatChord(chordNext)}</span>
      </Content>
    </>
  );
};

export default Chords;
